export enum UserRole {
  ITAdmin = 'IT_Admin',
  MIS = 'MIS',
  System = 'System',
  admin = 'Admin',
  allCenterAccess = 'All_Centre_Access',
  biharCenterManager = 'Bihar_Center_Manager',
  biharCivilSurgen = 'Bihar_Civil_Surgen',
  biharCivilSurgeon = 'Bihar Civil Surgeon',
  biharDS = 'Bihar_DS',
  biharFinance = 'Bihar_Finance',
  biharStateHealthSociety = 'Bihar_State_Health_Society',
  centerManager = 'Center_Manager',
  civilSurgeon = 'Civil Surgeon',
  dietitian = 'Dietitian',
  financeAR = 'Finance_AR',
  guest = 'Guest',
  hospital = 'Hospital',
  nephrologist = 'Nephrologist',
  opsManager = 'Ops_Manager',
  qualityManager = 'Quality_Manager',
  shsbFinance = 'Shsb Finance',
  superintendent = 'Superintendent',
  technician = 'Technician',
  iotDraft = 'IOT_Draft',
  autoInventory = 'Auto_Inventory',
  bme = 'bme',
  srBme = 'sr_bme',
  bmeHead = 'bme_head',
  clusterManager = 'cluster_manager',
  financeManager = 'finance_manager',
  zonalManager = 'zonal_manger',
  scmManager = 'scm_manager',
  roEngineer = 'ro_engineer',
  wareHouseBme = 'ware_house_bme',
  opsClusterManager = 'Ops_Cluster_Manager',
  qualityClusterManager = 'Quality_Cluster_manager',
  sherlockCM = 'Sherlock_CM',
  HR = 'HR',
  Vigilance = 'Vigilance',
  biharClusterManager = 'Bihar_Cluster_Manager',
  guestQrCode = 'guest_qr_code'

}
